export const timeDifference = timeStamp => {
    const current = new Date().getTime();
    const msPerMinute = 60 * 1000;
    const msPerHour = msPerMinute * 60;
    const msPerDay = msPerHour * 24;
    const msPerMonth = msPerDay * 30;
    const elapsed = current - new Date(timeStamp).getTime();
    if (isNaN(elapsed)) {
        return 'Invalid Date';
    }
    let calcTime;
    if (elapsed < msPerMinute) {
        return 'Just Now';
    }
    else if (elapsed < msPerHour) {
        calcTime = Math.round(elapsed / msPerMinute);
        return calcTime === 1 ? '1 minute ago' : calcTime + ' minutes ago';
    }
    else if (elapsed < msPerDay) {
        calcTime = Math.round(elapsed / msPerHour);
        return calcTime === 1 ? '1 hour ago' : calcTime + ' hours ago';
    }
    else if (elapsed < msPerMonth) {
        calcTime = Math.round(elapsed / msPerDay);
        if (calcTime < 8) {
            return calcTime === 1 ? '1 day ago' : calcTime + ' days ago';
        }
        else {
            return dateToString(timeStamp);
        }
    }
    else {
        return dateToString(timeStamp);
    }
};
export const dateToString = timeStamp => new Date(timeStamp).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
});
export const timeToString = ts => new Date(ts).toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: 'numeric',
});
//# sourceMappingURL=timeSince.js.map